import { Icon } from "./Icon";

export const Order = () => (
  <div className="orderContainer">
    <div className="orderButton left">
      <a
        href="https://wingstop.com/order/action/carryout/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon name="Carryout" social />
        <div className="orderText">
          <h4>Order</h4>
          <h2>Carryout</h2>
        </div>
      </a>
    </div>
    <div className="orderButton right">
      <a
        href="https://wingstop.com/order/action/delivery/"
        className="orderButton"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon name="Delivery" social />
        <div className="orderText">
          <h4>Order</h4>
          <h2>Delivery</h2>
        </div>
      </a>
    </div>
  </div>
);
